export enum CategoryStatus {
  ACTIVE = 'active',
  ARCHIVE = 'archive'
}

export enum PromptStatus {
  Active = 'Active',
  Archive = 'Archive'
}

export enum PromptTag {
  Hydration = 'Hydration',
  Medication = 'Medication',
  Sleep = 'Sleep',
  Routine = 'Routine',
  Anxiety = 'Anxiety',
  Stress = 'Stress',
  Calm = 'Calm',
  Encouragement = 'Encouragement',
  Mobility = 'Mobility',
  Nutrition = 'Nutrition',
  Loneliness = 'Loneliness',
  Gratitude = 'Gratitude',
  MemorySupport = 'Memory Support',
  Meditation = 'Meditation',
  Scripture = 'Scripture',
  Game = 'Game',
  Reminiscence = 'Reminiscence',
  News = 'News',
  Greeting = 'Greeting'
}

export enum PromptCategory {
  Wellbeing = 'wellbeing',
  Health = 'health',
  Spirituality = 'spirituality',
  EmotionalSupport = 'emotional_support',
  CognitiveSupport = 'cognitive_support',
  Activity = 'activity',
  Sleep = 'sleep',
  SocialConnection = 'social_connection',
  Other = 'other'
}

export enum BestDeliveryTime {
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening',
  ANY = 'ANY'
}

export enum PromptType {
  Adherence = 'Adherence',
  Conversation = 'Conversation',
  Monitoring = 'Monitoring',
  Activity = 'Activity',
  Assessment = 'Assessment'
}

export enum PromptSubType {
  Acknowledgement = 'Acknowledgement',
  MedicationConfirmation = 'Medication Confirmation',
  CheckIns = 'Check-ins',
  EngagementTopics = 'Engagement Topics',
  HealthWellbeing = 'Health & Wellbeing',
  BrainGames = 'Brain Games',
  Meditation = 'Meditation',
  Spirituality = 'Spirituality',
  MentalHealth = 'Mental Health',
  PhysicalHealth = 'Physical Health'
}

export enum DeliverableEventName {
  HydrationReminder = 'Hydration Reminder',
  MedicationReminder = 'Medication Reminder',
  MorningGreeting = 'Morning Greeting',
  NutritionCheckIn = 'Nutrition Check-in',
  GratitudePrompt = 'Gratitude Prompt',
  MobilityCheckIn = 'Mobility check-in',
  SleepQuality = 'Sleep Quality',
  BrainGames = 'Brain Games',
  Meditation = 'Meditation',
  DailyScripture = 'Daily Scripture',
  PHQ9 = 'PHQ-9',
  GDS15 = 'GDS-15',
  SARCF = 'SARC-F'
}
